const API = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="0.995315552 4.55 5.54531555 9.11 5.54531555 5.28 16 5.28 16 3.72 5.54531555 3.72 5.54531555 0" transform="translate(8.497658, 4.555000) scale(-1, 1) translate(-8.497658, -4.555000)"/><polygon points="8.8817842e-15 11.55 4.55 16.11 4.55 12.28 15.0046844 12.28 15.0046844 10.72 4.55 10.72 4.55 7"/></svg>',
};

export { API as default };
